type AppMode = 'tg' | 'web'

const mode = (import.meta.env.VITE_APP_MODE ?? 'tg') as AppMode

export const ENV = {
  APP_MODE: mode,
  IS_TG: mode === 'tg',
  IS_WEB: mode === 'web',
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? '',
  /** Внешняя ссылка на оплату курса (EU-сервис); может переопределяться course.payment_url. */
  PAYMENT_URL: import.meta.env.VITE_PAYMENT_URL ?? '',
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const
